import { Component, OnInit, Input, OnDestroy, ViewEncapsulation } from '@angular/core';
import { CovidService} from '../../covid.service';

@Component({
  selector: 'app-feed',
  templateUrl: './feed.component.html',
  styleUrls: ['./feed.component.less'],
  encapsulation: ViewEncapsulation.None,
})
export class FeedComponent implements OnInit, OnDestroy {
  @Input() view: string;
  data = null;
  scientists = null;
  page = 1;
  itemsPerPage = 20;
  tweets = null;

  constructor(private service: CovidService) { }

  ngOnInit(): void {
    this.getData();
  }

  getData() {
    this.scientists = this.service.getScientist(this.page).subscribe(response => {
      this.data = response;
    });
  }

  moreData($event) {
    this.page = $event.pageIndex;
    this.getData();
    window.scrollTo(0, 0);
  }

  handleError($event) {
    $event.target.src = this.service.twett;
  }

  linkify(inputText) {
    let replacedText;
    const replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
    replacedText = inputText.replace(replacePattern1, '<a href="$1" class="content__linked" target="_blank">$1</a>');

    // //URLs starting with www. (without // before it, or it'd re-link the ones done above)
    const replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
    replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2"class="content__linked" target="_blank">$2</a>');

    // //Change email addresses to mailto:: links
    const replacePattern3 = /(\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,6})/gim;
    replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1" class="content__linked">$1</a>');

    return replacedText;
  }

  ngOnDestroy() {
    this.tweets.unsubscribe();
    this.scientists.unsubscribe();
  }

}
